import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { render } from 'react-dom';
import LifescoreBar from './LifescoreBar';
import ScoreModal from './ScoreModal';
const lifeScoreModal = document.getElementById('life_score_bar');
if (lifeScoreModal) {
    render(_jsx(LifescoreBar, { path: lifeScoreModal.getAttribute('data-path'), lifeScore: lifeScoreModal.getAttribute('data-life-score') }), lifeScoreModal);
}
const scoreModal = document.getElementById('score_modal');
if (scoreModal) {
    render(_jsx(ScoreModal, {}), scoreModal);
}
